import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { makeRequest } from '../../utils/makeRequest';
import * as urls from '../../utils/urlConst';
import { useSelector } from 'react-redux';
import toastNotify from '../../utils/toastNotify';
import { removeLoginSession } from '../../utils/common';
import { getIsAutheticate } from '../../utils/common';
import { exceptionLog } from '../../utils/common';

const Error404 = () => {

    const navigate = useNavigate();
    const bankLogo = useSelector((state: any) => state.layout.bankLogo);
    window.history.forward();
    const isAuthenticate = getIsAutheticate();

    const LoginOut = async () => {
        if (isAuthenticate) {
            try {
                const payload = {};

                const config = {};

                await makeRequest('POST', urls.logOut, payload, config).then((result) => {
                    if (result.STATUS === '0') {
                        removeLoginSession();
                        navigate('/');
                    } else {
                        result.MESSAGE !== "No Data Found" && toastNotify(result.MESSAGE, 'error');
                    };
                })
            } catch (error: any) {
                if (error.status !== 403) {
                    await exceptionLog(error, "Logout", "N");
                }
            }
        } else {
            removeLoginSession();
            navigate('/');
        }
    };

    return (
        <div>
            <Container style={{ height: '100vh', padding: '0 10px 10px 10px' }} className='d-flex justify-content-center align-items-center'>
                <Row>
                    <Col md={6} className='d-none d-md-block'>
                        <div>
                            <img src="/imgaes/404.png" alt="" className='w-100' />
                        </div>
                    </Col>

                    <Col md={6} className='d-flex justify-content-center align-items-center flex-col pb-3'>
                        <div>
                            <div className="company-logo d-flex justify-content-center my-3">
                                <img
                                    src={bankLogo.loginLogo}
                                    alt="company-logo"
                                    style={{ width: bankLogo.loginLogoWidth, height: bankLogo.loginLogoHeight }}
                                />
                            </div>
                            <h1 style={{ fontSize: 80 }} className='fw-600 text-center'>404</h1>
                            <h2 className='h-1 text-center'>Page Not Found</h2>
                            <div className='mt-3'>
                                <p className='text-center text-slate-500'>We're sorry, the page you requested could not be found.</p>
                                <p className='text-center text-slate-500'>Please go back to the home page.</p>
                            </div>
                            <div className='d-flex justify-content-center mt-3'>
                                <Button
                                    variant="orange"
                                    type="submit"
                                    className="btn btn-orange"
                                    style={{
                                        width: 150,
                                    }}
                                    onClick={() => LoginOut()}
                                >
                                    Go Home
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Error404
